import { Component, Input, OnInit, Output, EventEmitter, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ExtVendorFile } from 'src/app/model/ExtVendorFile';
import { Constraint } from 'src/app/model/Plan';
import { ExtVendorFileService } from 'src/app/service/ext-vendor-file.service';

@Component({
    selector: 'app-ext-ven-files-typeahead',
    templateUrl: './ext-ven-files-typeahead.component.html',
    styleUrls: ['./ext-ven-files-typeahead.component.css'],
    standalone: false
})
export class ExtVenFilesTypeaheadComponent implements OnInit {

  queryText: string = "";
  queryTextChanged = new Subject<string>();
  extFiles: ExtVendorFile[] = [];
  queryTextSubscription: Subscription;
  showList: boolean = false;
  selectedExtVenderFile: ExtVendorFile;
  scrollHeight: string = "";

  @ViewChild('extVenFileInputText') extVendFileInputText: ElementRef;
  
  @Input()selectedExtVenderFileName:string = "";
  @Input()constraints:Constraint[];
  @Input() identifier: string = '';

  @Output() onSelectFile: EventEmitter<ExtVendorFile> = new EventEmitter();
  @Output() onDeselectFile: EventEmitter<void> = new EventEmitter();
  
  constructor(private extVenFileSrv: ExtVendorFileService,
              private eleRef: ElementRef,) { }

  ngOnInit(): void {
    this.queryTextSubscription = this.queryTextChanged.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(query  => {
        if(query != ''){
          this.extFiles = [];
          this.showList = false;
          if(this.constraints && this.constraints.length > 0){
            let fileExtensions:string[] = [];
            this.constraints.forEach( (constraint:Constraint) => {
              if(constraint.name == "FileExtension"){
                fileExtensions.push(constraint.value);
              }
            })
            this.extVenFileSrv.getExtVenFilesAndExtension(query.trim(), fileExtensions).pipe(
              tap(resp => {
                this.extFiles = resp.body;
                this.showList = true;
                this.setScrollHeight();
              })
            ).subscribe();
          }else{
            this.extVenFileSrv.getExtVenFilesByName(query.trim()).pipe(
              tap(resp => {
                this.extFiles = resp.body;
                this.showList = true;
                this.setScrollHeight();
              })
            ).subscribe();
          }
          
        }
      }),
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.queryTextSubscription.unsubscribe(); 
  }

  onQueryTextChanged(query:string){
    this.queryTextChanged.next(query);
  }

  onSelect(extFile: ExtVendorFile): void {
    this.showList = false;
    this.queryText = "";
    this.selectedExtVenderFile = extFile;
    this.selectedExtVenderFileName = this.selectedExtVenderFile.name;
    this.onSelectFile.emit(extFile);
  }

  removeSelectedFile(): void {
    this.onDeselectFile.emit();
    this.selectedExtVenderFile = undefined;
    this.selectedExtVenderFileName = "";
  }

  setScrollHeight(): void {
    if(this.extFiles.length == 0){
      this.scrollHeight = 'unset';
    }else if(this.extFiles.length < 3){
      this.scrollHeight = this.extFiles.length * 40 + 'px';
    }else {
      this.scrollHeight = '110px';
    }
  }

  @HostListener("document:click", ["$event"])
  clickout($event) {
    if (this.extVendFileInputText && !this.extVendFileInputText.nativeElement.contains($event.target)){
      this.showList = false;
      this.queryText = "";
    }
  }
}
